// extracted by mini-css-extract-plugin
export default {"container":"Map2D_container__UJQhv","map":"Map2D_map__iYyCK"};